// extracted by mini-css-extract-plugin
export default {"popup_menu":"UserMenu_popup_menu__HLUER","show_menu":"UserMenu_show_menu__trHl2","menu_item":"UserMenu_menu_item__z6Yls"};